module.exports = __webpack_public_path__ + "img/68ne.948f926f.svg";